import { useState, useEffect } from "react";
import { calculateService } from "../../Services/calculate.service";
import { Oval } from "react-loader-spinner";
import * as Image from "../../assets/images";
import { ButtonDog, ButtonCat } from "../../assets/svg";
import { shipBox } from "../../assets/svg";

import { useTranslation } from "react-i18next";

function CalculatedOrder({
  petInfo,
  data,
  setPreferredOrder,
  isAddingBasket,
  setIsAddingBasket,
  petType
}) {
  const [selectedAmount, setSelectedAmount] = useState(2);
  const [selectedDelivery, setSelectedDelivery] = useState(1);
  const [selectedOrderType, setSelectedOrderType] = useState(1);
  const [calculatedData, setCalculatedData] = useState([]);
  const [preferredFoodPacket, setPreferredFoodPacket] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const selectAmount = (amount) => {
    setSelectedAmount(selectedAmount == amount ? "" : amount);
  };

  const selectDelivery = (delivery) => {
    setSelectedDelivery(selectedDelivery == delivery ? "" : delivery);
  };

  const format = (num) => {
    var formattedOutput = new Intl.NumberFormat("tr-TR", {
      style: "currency",
      currency: "TRY",
      minimumFractionDigits: 2,
    });
    return formattedOutput.format(num);
  };

  const sendPetInfo = async () => {
    const calculate = await calculateService.response(data);
    setCalculatedData(calculate.data);
    setIsLoading(false);
    setIsAddingBasket(false);
  };

  const {t} = useTranslation();

  useEffect(() => {
    sendPetInfo();
  }, []);

  useEffect(() => {
    if (selectedAmount === 1) {
      setPreferredFoodPacket(calculatedData[0]?.fifteenDays);
    } else if (selectedAmount === 2) {
      setPreferredFoodPacket(calculatedData[0]?.monthly);
    } else {
      setPreferredFoodPacket(calculatedData[0]?.twoMonths);
    }
  }, [selectedAmount, calculatedData]);

  useEffect(() => {
    setPreferredOrder({
      id: petInfo.id,
      isSubscribed: selectedOrderType !== 1,
      inDelivery: selectedDelivery === 1,
      dateAmount: selectedAmount === 1 ? 15 : selectedAmount === 2 ? 30 : 60,
    });
  }, [
    preferredFoodPacket,
    selectedAmount,
    selectedDelivery,
    selectedOrderType,
  ]);

  return (
    <div className="md:h-9/10 w-10/12 max-w-4xl mt-16 mb-8 mx-4 flex flex-col justify-center items-center">
      {isLoading ? (
        petType == 'dog' ? <ButtonDog className="h-24 animate-bounce mt-8 md:mt-24" /> : <ButtonCat className="h-24 animate-bounce mt-8 md:mt-24" /> 
      ) : (
        <div className="relative w-full h-full">
          {isAddingBasket && (
            <div className="absolute bg-[#F6F6EC] w-full h-full opacity-90 flex flex-col justify-center items-center" style={{height: '100%', zIndex: 99}}>
              {petType == 'dog' ? <ButtonDog className="z-10 h-24 animate-bounce mt-8 md:mt-24 opacity-100 " /> : <ButtonCat className="z-10 h-24 animate-bounce mt-8 md:mt-24 opacity-100 " /> }
              <div className="text-[#FF8C01] font-poppins font-bold  text-center mt-6 text-2xl ">
                {t("addingToCartMessage")}
              </div>
            </div>
          )}
          {petInfo.food.length > 1 ? (
            <div className="grid grid-cols-1">
              <div className="text-2xl text-lime-600 font-poppins font-bold  text-center mb-6">
                {t("dailyRecommendation")}{" "}
                <span className="text-[#FF8C01]">{`${calculatedData[0]?.dailyGr}gr`}</span>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {petInfo.food.map((item, index) => (
                  <div key={index}>
                    <div className="flex-col justify-center">
                      <img
                        className={`mb-2 mt-2 object-cover w-64 inline-block scale-[175%] `}
                        src={item?.src}
                        alt={"Food"}
                      />
                    </div>
                  </div>
                ))}
              </div>
              <div className="flex flex-col md:flex-row gap-4 items-center justify-center lg:px-6">
                <div className="flex w-full md:w-[50%] h-fit flex-col gap-2 text-[#FF8C01] ">
                  <div className="text-2xl font-bold self-start">{t("quantity")}</div>
                  <div className="flex flex-col md:flex-row border p-2 gap-4 md:gap-8  border-lime-600 rounded-lg h-full overflow-hidden relative">
                    <div className="flex gap-1  h-full">
                      <div
                        onClick={() => selectAmount(1)}
                        className="w-6 h-6 border cursor-pointer border-[#FF8C01] rounded-sm relative"
                      >
                        {selectedAmount == 1 && (
                          <img
                            className="w-6 h-6 absolute -top-[2px]  -right-[2px] -z-10 "
                            src={Image.CheckIcon}
                          />
                        )}
                      </div>
                      <div>{t("15DayKitoFresh")}</div>
                    </div>
                  </div>
                  <div className="flex flex-col md:flex-row border p-2 gap-4 md:gap-8  border-lime-600 rounded-lg h-full overflow-hidden relative">
                    <div className="flex gap-1 h-full">
                      <div
                        onClick={() => selectAmount(2)}
                        className="w-6 h-6 border border-[#FF8C01] cursor-pointer rounded-sm relative"
                      >
                        {selectedAmount == 2 && (
                          <img
                            className="w-6 h-6 absolute -top-[2px]  -right-[2px] -z-10 "
                            src={Image.CheckIcon}
                          />
                        )}
                      </div>
                      <div>{t("oneMonthKitoFresh")}</div>
                    </div>
                  </div>
                </div>

                <div className=" border-2 w-full md:w-[40%] h-[120px] border-lime-600 mx-auto relative rounded-[1px] lg:mt-6">
                  <img
                    className={`w-12 md:w-12 mx-auto z-10 absolute  m-auto left-0 right-0 -top-6 backdrop-blur-md text-lime-600 rounded-2xl `}
                    src={shipBox}
                    alt={"Bowl"}
                  />
                  <div className="flex flex-col text-center text-lg justify-center items-center text-[#FF8C01] mt-[28px] leading-[18px]">
                    <div className="font-bold">{t("packageContents")}</div>
                    <div>
                      {selectedAmount == 1
                        ? calculatedData[0].fifteenDays.packageGr
                        : calculatedData[0].monthly.packageGr}{" "}
                      gr X{" "}
                      {selectedAmount == 1
                        ? calculatedData[0]?.fifteenDays?.package
                        : calculatedData[0]?.monthly?.package}{" "}
                      {petInfo?.food[0]?.name}
                    </div>
                    <div>+</div>
                    <div>
                      {selectedAmount == 1
                        ? calculatedData[0].fifteenDays.packageGr
                        : calculatedData[0].monthly.packageGr}{" "}
                      gr X{" "}
                      {selectedAmount == 1
                        ? calculatedData[0]?.fifteenDays?.package
                        : calculatedData[0]?.monthly?.package}{" "}
                      {petInfo?.food[1]?.name}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className="grid grid-cols-1 lg:grid-cols-6">
              <div className="flex-col grid-start-4 col-span-2 lg:col-span-2 lg:mt-8">
                <img
                  className={`w-80 md:w-80 mb-2 mt-2 mx-auto scale-[150%]`}
                  src={petInfo?.food[0].src}
                  alt={"Bowl"}
                />
                <div className="border-2 w-[90%] h-24 border-lime-600 mx-auto relative rounded-[1px] lg:mt-6">
                  <img
                    className={`w-12 md:w-12 mx-auto z-10 absolute  m-auto left-0 right-0 -top-6 backdrop-blur-md text-lime-600 rounded-2xl `}
                    src={shipBox}
                    alt={"Bowl"}
                  />
                  <div className="flex flex-col text-center text-lg justify-center items-center text-[#FF8C01] mt-[28px] leading-[18px]">
                    <div className="font-bold">{t("packageContents")}</div>
                    <div>
                      {selectedAmount == 1
                        ? calculatedData[0].fifteenDays.packageGr
                        : calculatedData[0].monthly.packageGr}{" "}
                      gr X
                    </div>
                    <div>
                      {selectedAmount == 1
                        ? calculatedData[0]?.fifteenDays?.package
                        : calculatedData[0]?.monthly?.package}{" "}
                      paket {petInfo.food[0]?.name}
                    </div>
                  </div>
                </div>
                {/* <div
                  className={`mx-auto mt-2 w-48 items-center px-4 py-2 border shadow-sm text-2xl font-bold rounded-lg  
                    ${"bg-transparent border-lime-600 text-[#FF8C01] cursor-default bg-opacity-20 bg-lime-700"}`}
                >
                  {petInfo.food[0]?.name}
                </div>
                <div
                  className={`mx-auto mt-2 w-48 items-center px-4 py-2 border shadow-sm text-2xl font-bold rounded-lg  
                    ${"bg-transparent border-lime-600 text-[#FF8C01] cursor-default"}`}
                >
                  {`${format(calculatedData[0]?.monthly?.price)}    ₺`}
                </div>
                <div className="mt-2 text-xs text-lime-600">
                  *1 aylık Kito Fresh paketi için ödeyeceğiniz tutar.
                </div> */}
              </div>
              <div className="flex-col mt-6 ml-4 grid-start-2 col-span-4 md:col-span-4">
                <div className="text-2xl text-lime-600 font-poppins font-bold mt-2 text-left">
                  {t("dailyRecommendation")}{" "}
                  <span className="text-[#FF8C01]">{`${calculatedData[0]?.dailyGr}gr`}</span>
                </div>
                <div className="text-lg text-lime-600 font-poppins font-normal mt-6 text-left mb-10">
                  <span className="text-[#FF8C01] font-bold text-lg">
                    {t("contents")}:
                  </span>{" "}
                  {petInfo.food[0]?.ingredient?.map((item, index) => (
                    <span key={item}>{`${item}${
                      petInfo.food[0]?.ingredient?.length-1 > index ? ", " : " "
                    }`}</span>
                  ))}
                </div>
                <div className="flex flex-col gap-2 text-[#FF8C01] lg:w-[80%]">
                  <div className="text-2xl font-bold self-start">{t("quantity")}</div>
                  <div className="flex flex-col md:flex-row border p-2 border-lime-600 rounded-lg h-full w-full overflow-hidden relative">
                    <div className="flex gap-1 h-full margin-inline-start w-56 p-1">
                      <div
                        onClick={() => selectAmount(1)}
                        className="w-6 h-6 border cursor-pointer border-[#FF8C01] rounded-sm relative"
                      >
                        {selectedAmount == 1 && (
                          <img
                            className="w-6 h-6 absolute -top-[2px]  -right-[2px] -z-10 "
                            src={Image.CheckIcon}
                          />
                        )}
                      </div>
                      <div>{t("15DayKitoFresh")}</div>
                    </div>
                    <div className="border-r hidden md:block border-lime-600 h-44 absolute left-56 top-0" />
                    <div className="flex gap-1 h-full margin-inline-start p-1">
                      <div
                        onClick={() => selectAmount(2)}
                        className="w-6 h-6 border border-[#FF8C01] cursor-pointer rounded-sm relative"
                      >
                        {selectedAmount == 2 && (
                          <img
                            className="w-6 h-6 absolute -top-[2px]  -right-[2px] -z-10 "
                            src={Image.CheckIcon}
                          />
                        )}
                      </div>
                      <div>{t("oneMonthKitoFresh")}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* <div className="text-2xl text-lime-600 font-poppins font-bold mt-2">
            Köpeğiniz için tavsiye ettiğimiz günlük Kito Fresh tüketim miktarı{" "}
            <span className="text-[#FF8C01]">{`${calculatedData[0]?.dailyGr}gr`}</span>
            'dır
          </div>
          <div className="flex justify-center">
            <div className={`relative flex flex-wrap justify-center mt-6 `}>
              {petInfo.food.map((food) => (
                <div
                  key={food.id}
                  className="flex-col items-baseline justify-center m-2 "
                >
                  <div className="flex justify-center h-32 mb-4 sm:h-32">
                    {food.svg}
                  </div>
                  <button
                    type="button"
                    className={`inline-flex items-center px-4 py-1 border  shadow-sm text-base font-medium rounded
                    ${"bg-transparent border-lime-600 text-[#FF8C01] cursor-default"}`}
                  >
                    {food.name}
                  </button>
                </div>
              ))}
            </div>
          </div> */}
          {/* <div className="w-full xl:w-9/12 mt-16 relative ">
            <div className="h-[500px] sm:h-[350px] xl:h-64 w-full border-2 border-lime-600 rounded-3xl relative my-auto ">

              <div className="sm:h-64 xl:flex xl:items-center">
                <div className="h-[350px] mt-6 xl:mt-0 sm:h-[200px] lg:h-48 sm:ml-16 xl:w-8/12 sm:flex sm:justify-center">
                  <div className="flex-col pt-4 w-[200px] mx-auto sm:mx-0  sm:mr-6 lg:mr-0 ">
                    <div className="text-2xl sm:text-4xl text-[#FF8C01] font-poppins font-bold text-left">
                      Miktar
                    </div>
                    <fieldset className="mt-4 w-54">
                      <div className="space-y-1">
                        {kitoAmount.map((item) => (
                          <div
                            key={item.id}
                            onClick={() => {
                              selectAmount(item.id);
                            }}
                            className="flex items-center"
                          >
                            <div className="w-4 h-4 relative border border-[#FF8C01] rounded-sm">
                              {selectedAmount === item.id ? (
                                <CheckIcon
                                  className="w-6 h-6 absolute -top-[6px] -left-[3px] z-10 text-lime-600 font-poppins font-bold "
                                  aria-hidden="true"
                                />
                              ) : null}
                            </div>
                            <div className="text-[#FF8C01] font-poppins text-left text-lg ml-1">
                              {item.title}
                            </div>
                          </div>
                        ))}
                      </div>
                    </fieldset>
                  </div>
                  <div className="w-[200px] sm:w-auto mx-auto sm:mx-0 mt-8 sm:mt-0 lg:ml-6 sm:pt-4 sm:pr-6 xl:border-r xl:border-lime-600">
                    <div className="text-2xl sm:text-4xl text-[#FF8C01] font-poppins font-bold text-left">
                      Teslimat Yeri
                    </div>
                    <fieldset className="mt-4 w-54">
                      <div className="space-y-1">
                        {delivery.map((item) => (
                          <div
                            key={item.id}
                            onClick={() => {
                              selectDelivery(item.id);
                            }}
                            className="flex items-center"
                          >
                            <div className="w-4 h-4 relative border border-[#FF8C01] rounded-sm">
                              {selectedDelivery === item.id ? (
                                <CheckIcon
                                  className="w-6 h-6 absolute -top-[6px] -left-[3px] z-10 text-lime-600 font-poppins font-bold "
                                  aria-hidden="true"
                                />
                              ) : null}
                            </div>
                            <div className="text-[#FF8C01] font-poppins text-left text-lg ml-1">
                              {item.title}
                            </div>
                          </div>
                        ))}
                      </div>
                    </fieldset>
                  </div>
                </div>
                <div className="xl:w-4/12 mb-6 sm:mb-0 sm:mt-4 xl:mt-0  flex flex-col justify-center">
                  <div className="">
                    <div className="text-[#FF8C01] mx-auto font-poppins text-center text-sm ">{`${preferredFoodPacket?.kg} kg Kito Fresh`}</div>
                    <div className="w-28 p-[2px] mx-auto text-lime-600 text-xs font-poppins border-t border-[#FF8C01] ">{`${preferredFoodPacket?.price}₺ /Aylık`}</div>
                    <div className="w-28 p-[2px]  mx-auto text-lime-600 text-xs font-poppins border-b border-[#FF8C01] ">{`${calculatedData[0]?.deliveryAmount}₺ /Kargo`}</div>
                    <div className="text-[#FF8C01] mx-auto font-poppins text-base font-bold ">{`${
                      preferredFoodPacket?.price +
                      calculatedData[0]?.deliveryAmount
                    }₺ /Toplam`}</div>
                  </div>
                </div>
              </div>
            </div>
          </div> */}
        </div>
      )}
    </div>
  );
}

export default CalculatedOrder;
